import api from "./index";

export interface EmployeeListParams {
  id: string;
  userIds?: Array<string>;
  roles?: Array<string>;
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: EmployeeListParams, options?: any) => {
  return api.EmployeeApi.list(
    params.id,
    params.userIds,
    params.roles,
    params.offset,
    params.limit,
    options
  );
};
